// auth-redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const authKey = route.paramMap.get('authKey'); 
    
    if (authKey === 'logout' || authKey === 'session') {
      return true;
    }

    const storedKeySuffix = localStorage.getItem('keySuffix');
    if (storedKeySuffix) {
      const userContext = localStorage.getItem(storedKeySuffix + 'userContext');
      const sessionId = localStorage.getItem(storedKeySuffix + 'sessionId');

      if (userContext && sessionId) {
        this.router.navigateByUrl('/dashboard');
        return false;  
      }
    }

    return true;  
  }
}